var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4946 18.8771L20 2.49622L1.50545 18.8771C0.885298 19.4264 0.827843 20.3744 1.37712 20.9945C1.9264 21.6147 2.8744 21.6721 3.49455 21.1229L5 19.7895V33.5C5 35.433 6.56701 37 8.5 37H14.9941C14.9961 37 14.998 37 15 37C15.002 37 15.0039 37 15.0059 37H24.9941C24.9961 37 24.998 37 25 37C25.002 37 25.0039 37 25.0059 37H31C32.933 37 34.5 35.433 34.5 33.5V19.5C34.5 19.4456 34.4971 19.3919 34.4915 19.3391L36.5054 21.1229C37.1256 21.6721 38.0736 21.6147 38.6229 20.9945C39.1722 20.3744 39.1147 19.4264 38.4946 18.8771ZM26.5 34H31C31.2761 34 31.5 33.7761 31.5 33.5V19.5C31.5 18.6783 32.1607 18.011 32.9798 18.0001L20 6.50376L6.94472 18.067C7.55601 18.2565 8 18.8264 8 19.5V33.5C8 33.7761 8.22386 34 8.5 34H13.5V25C13.5 23.067 15.067 21.5 17 21.5H23C24.933 21.5 26.5 23.067 26.5 25V34ZM16.5 34H23.5V25C23.5 24.7239 23.2761 24.5 23 24.5H17C16.7239 24.5 16.5 24.7239 16.5 25V34Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.cd9c5f47347f448246047b06cc30a403.svg";
export { ForwardRef as ReactComponent };